import React from 'react'

import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import Buttons from "../components/Buttons";

const CommodityCategoryPopup = ({ data, data1, dropdownOptions })=> {
  return (
    <div className="w-full">
      <div className="relative w-full h-full max-w-xl md:h-auto mx-auto">
        <div className="relative bg-white rounded-lg shadow">
          <div className="px-6 py-6 lg:px-8">
            <form className="space-y-6" action="#">
              <AutoDropDown
                classStar="text-red-500"
                title={"Commodity Type"}
                options={ data1} 
                placeholder={"Select"}
                name={"commodityType"}
                selectedOption={
                    data?.MstCommodityTypeId
                      ? data1.find(x => x.value === data.MstCommodityTypeId)
                      : ""
                  }
                Class="custom-class"
                tabIndex="1"
                disabled="true"
              />
             

              <InputText
                classStar="text-red-500"
                inputType={"text"}
                disabled={true}
                title={"Category"}
                name={"Category"}
                content={data.CommodityCategory_en}
              
              />
            
              <TextArea
                title="Description"
                name="description"
                rows={4}
                content={data.Description}
                disabled={true}
                
              />

              
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommodityCategoryPopup;